import { AMNoteItem } from 'src/app/accountmanagers/submittals/model/am-submittals.model';
import {
    loadCandidateClinicalHistory,
    loadCandidateClinicalHistoryFailed,
    loadCandidateClinicalHistorySuccess,
    loadSubmittalNotes,
    loadSubmittalNotesFailed,
    loadSubmittalNotesSuccess
} from '../actions/clinical-review-history.actions';
import { createReducer, on } from '@ngrx/store';
import { ClinicalReviewHistory } from '../../review-queue/models/clinical-review-history.model';

export interface SubmittalNotes {
    submittalId: number;
    notes: AMNoteItem[];
}

export interface ClinicalReviewHistoryState {
    candidateId: number;
    history: ClinicalReviewHistory[];
    notes: SubmittalNotes[];
    error?: string;
    exception?: unknown;
}

const initialState: ClinicalReviewHistoryState = {
    candidateId: null,
    history: [],
    notes: [],
    error: null,
    exception: null
};

export const clinicalReviewHistoryReducer = createReducer(
    initialState,
    on(
        loadCandidateClinicalHistory,
        (state): ClinicalReviewHistoryState => ({
            ...state
        })
    ),

    on(
        loadCandidateClinicalHistorySuccess,
        (state, action): ClinicalReviewHistoryState => ({
            ...state,
            candidateId: action.candidateId,
            history: action.history,
            notes: []
        })
    ),

    on(
        loadCandidateClinicalHistoryFailed,
        (state, action): ClinicalReviewHistoryState => ({
            ...state,
            error: action.error,
            exception: action.exception
        })
    ),

    on(
        loadSubmittalNotes,
        (state): ClinicalReviewHistoryState => ({
            ...state
        })
    ),

    on(
        loadSubmittalNotesSuccess,
        (state, action): ClinicalReviewHistoryState => ({
            ...state,
            notes: [
                ...state.notes.filter((n) => n.submittalId !== action.submittalId),
                { submittalId: action.submittalId, notes: action.notes }
            ]
        })
    ),

    on(
        loadSubmittalNotesFailed,
        (state, action): ClinicalReviewHistoryState => ({
            ...state,
            error: action.error,
            exception: action.exception
        })
    )
);
